if (typeof L2H === 'undefined' || L2H === null) { window.L2H = {}; }

L2H.BrokenPhotoCheck = class BrokenPhotoCheck {
  call(photos) {
    var badPhotos = [];
    var promises = [];

    photos.forEach((photo) => {
      var img = new Image();
      let deferred = new L2H.$.Deferred();
      promises.push(deferred);

      L2H.$(img)
        .on('error', () => {
          if (L2H.debug) { console.log(`Image with src ${photo.thumb_url} is busted`); }
          badPhotos.push(photo);
          deferred.resolve();
        })
        .on('load', () => {
          deferred.resolve();
        });

      if (L2H.preferences.useLargeThumbs) {
        img.src = photo.url;
      } else {
        img.src = photo.thumb_url;
      }

    });

    L2H.$.when(...promises).then(() => {
      if (badPhotos.length) {
        this.reportError(badPhotos);
      }
    });
  }

  reportError(photos) {
    let url = `${L2H.appURL}api/v1/stats/track_broken_photo`;

    let deferred = new L2H.$.Deferred();

    let photoIDs = photos.map(photo => photo.id);

    timeoutID = setTimeout(() => {
      deferred.resolve()
    }, 1000);

    L2H.$.ajax({
      method: "GET",
      url: url,
      data: {photo_ids: photoIDs},
      dataType: "jsonp"
    }).done((data) => {
      // do nothing
      return
    }).always(() => {
      window.clearTimeout(timeoutID);
      deferred.resolve();
    })

    return deferred.promise()
  }
}
